/**
 @author xiaoye
 @date 2020/4/21 10:48 上午
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;

//获取数据接入简易列表
let token01 = null;
export const GetDataSourceList = async (data) => {
    if (token01) {
        token01.cancel({status: 'cancel'});
    }
    token01 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[3] + "/GetDataSourceList?" + qs.stringify(data),
        method: "get",
        token: token01.token,
    })
};

//测试数据接入还可不可以连接上
let token02 = null;
export const GetConnByDataSource = async (data) => {
    if (token02) {
        token02.cancel({status: 'cancel'});
    }
    token02 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetConnByDataSource?" + qs.stringify(data),
        method: "get",
        token: token02.token,
    })
};

//获取数据接入的表名或者sheet名列表
let token03 = null;
export const GetTableNameBySourceID = async (data) => {
    if (token03) {
        token03.cancel({status: 'cancel'});
    }
    token03 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetTableNameBySourceID?" + qs.stringify(data),
        method: "get",
        token: token03.token,
    })
};


//测试数据接入还可不可以连接上
let token04 = null;
export const GetSqlListByUser = async (data) => {
    if (token04) {
        token04.cancel({status: 'cancel'});
    }
    token04 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetSqlListByUser?" + qs.stringify(data),
        method: "get",
        token: token04.token,
    })
};

//根据sql语句来获取信息
let token05 = null;
export const GetInfoBySql = async (data) => {
    if (token05) {
        token05.cancel({status: 'cancel'});
    }
    token05 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetInfoBySql",
        method: "post",
        data: data,
        token: token05.token,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//根据表名或sheet名来获取源信息
let token06 = null;
export const GetInfoByTableName = async (data) => {
    if (token06) {
        token06.cancel({status: 'cancel'});
    }
    token06 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetInfoByTableName?" + qs.stringify(data),
        method: "get",
        token: token06.token,
    })
};

//获取数据准备列表
let token07 = null;
export const GetDataSetList = async (data) => {
    if (token07) {
        token07.cancel({status: 'cancel'});
    }
    token07 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetDataSetList?" + qs.stringify(data),
        method: "get",
        token: token07.token,
    })
};

//删除数据准备列表
let token08 = null;
export const RemoveDataSet = async (data) => {
    if (token08) {
        token08.cancel({status: 'cancel'});
    }
    token08 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/RemoveDataSet?" + qs.stringify(data),
        method: "get",
        token: token08.token,
    })
};

//保存数据准备
let token09 = null;
export const SaveDataSet = async (data) => {
    if (token09) {
        token09.cancel({status: 'cancel'});
    }
    token09 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/SaveDataSet",
        method: "post",
        token: token09.token,
        data: data,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};


// 验证数据准备中同一用户是否存在相同名称
let token10 = null;
export const GetDataSetNameVerify = async (data) => {
    if (token10) {
        token10.cancel({status: 'cancel'});
    }
    token10 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetDataSetNameVerify?" + qs.stringify(data),
        method: "get",
        token: token10.token,
    })
};


//数据扩充弹窗，编译按钮
let token11 = null;
export const AddField = async (data) => {
    if (token11) {
        token11.cancel({status: 'cancel'});
    }
    token11 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/AddField",
        method: "post",
        token: token11.token,
        data: data,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//数据扩充弹窗，算法添加保存按钮
let token12 = null;
export const SaveTable = async (data) => {
    if (token12) {
        token12.cancel({status: 'cancel'});
    }
    token12 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/SaveTable",
        method: "post",
        token: token12.token,
        data: data,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//删除字段弹窗，确定按钮
let token13 = null;
export const DelField = async (data) => {
    if (token13) {
        token13.cancel({status: 'cancel'});
    }
    token13 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/DelField",
        method: "post",
        token: token13.token,
        data: data,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//数据扩充弹窗，条件添加保存按钮
let token14 = null;
export const AddCaseWhen = async (data) => {
    if (token14) {
        token14.cancel({status: 'cancel'});
    }
    token14 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/AddCaseWhen",
        method: "post",
        token: token14.token,
        data: data,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//数据关联，保存按钮
let token15 = null;
export const JoinTables = async (data) => {
    if (token15) {
        token15.cancel({status: 'cancel'});
    }
    token15 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/JoinTables",
        method: "post",
        token: token15.token,
        data: data,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};


//数据扩充，新数据扩充数量接口
let token16 = null;
export const GetFieldCount = async (data) => {
    if (token16) {
        token16.cancel({status: 'cancel'});
    }
    token16 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetFieldCount?" + qs.stringify(data),
        method: "get",
        token: token16.token,
    })
};

//根据字段名查询算法/条件
let token17 = null;
export const GetFieldinfo = async (data) => {
    if (token17) {
        token17.cancel({status: 'cancel'});
    }
    token17 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetFieldinfo?" + qs.stringify(data),
        method: "get",
        token: token17.token,
    })
};


//算法添加，修改按钮
let token18 = null;
export const UpdateFuns = async (data) => {
    if (token18) {
        token18.cancel({status: 'cancel'});
    }
    token18 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/UpdateFuns",
        method: "post",
        token: token18.token,
        data: data,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};
//条件字段修改
let token19 = null;
export const UpdateCase = async (data) => {
    if (token19) {
        token19.cancel({status: 'cancel'});
    }
    token19 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/UpdateCase",
        method: "post",
        token: token19.token,
        data: data,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//创建数据过滤
let token20 = null;
export const CreateFilter = async (data) => {
    if (token20) {
        token20.cancel({status: 'cancel'});
    }
    token20 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/CreateFilter",
        method: "post",
        token: token20.token,
        data: data,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//查询已删除字段
let token21 = null;
export const GetDelFieldsInfo = async (data) => {
    if (token21) {
        token21.cancel({status: 'cancel'});
    }
    token21 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetDelFieldsInfo?" + qs.stringify(data),
        method: "get",
        token: token21.token,
    })
};

//查询GetFilterInfo
let token22 = null;
export const GetFilterInfo = async (data) => {
    if (token22) {
        token22.cancel({status: 'cancel'});
    }
    token22 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetFilterInfo?" + qs.stringify(data),
        method: "get",
        token: token22.token,
    })
};

//查询GetFilterInfo
let token26 = null;
export const GetFieldsInfo = async (data) => {
    if (token26) {
        token26.cancel({status: 'cancel'});
    }
    token26 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetFieldsInfo?" + qs.stringify(data),
        method: "get",
        token: token26.token,
    })
};
//查询GetFilterInfo
let token23 = null;
export const GetFieldsInfo2 = async (data) => {
    if (token23) {
        token23.cancel({status: 'cancel'});
    }
    token23 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetFieldsInfo?" + qs.stringify(data),
        method: "get",
        token: token23.token,
    })
};

//恢复已删除字段
let token24 = null;
export const RestoreField = async (data) => {
    if (token24) {
        token24.cancel({status: 'cancel'});
    }
    token24 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/RestoreField",
        method: "post",
        token: token24.token,
        data: data,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//删除数据关联
let token25 = null;
export const DelTableJoin = async (data) => {
    if (token25) {
        token25.cancel({status: 'cancel'});
    }
    token25 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/DelTableJoin",
        method: "post",
        token: token25.token,
        data: data,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//删除数据关联
let token27 = null;
export const UpTypes = async (data) => {
    if (token27) {
        token27.cancel({status: 'cancel'});
    }
    token27 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/UpTypes",
        method: "post",
        token: token27.token,
        data: data,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};
//重置字段类型
let token28 = null;
export const GetFieldsDele = async (data) => {
    if (token28) {
        token28.cancel({status: 'cancel'});
    }
    token28 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetFieldsDele?" + qs.stringify(data),
        method: "get",
        token: token28.token,
    })
};

let token29 = null;
export const GetFields = async (data) => {
    if (token29) {
        token29.cancel({status: 'cancel'});
    }
    token29 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetFields?" + qs.stringify(data),
        method: "get",
        token: token29.token,
    })
};